import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import Barcode from "react-barcode";
import MyContext from "../../../MyContext";
export default function LabelPrinting({ userID }) {
  const { baseUrl, config } = useContext(MyContext);
  const [catalogue, setCatalogue] = useState([]);
  const [formData, setFormData] = useState({
    selectedCategory: "",
    selectedItem: null,
    mfgDate: "",
    expDate: "",
    mrp: "",
    quantity: 1,
  });
  const [itemsToPrint, setItemsToPrint] = useState([]);
  const [labels, setLabels] = useState([]);
  const [layout, setLayout] = useState("layout1");
  const printRef = useRef();
  const posRef = useRef();
  

  const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yy = String(date.getFullYear()).slice(-2); // last 2 digits of year
  return `${dd}/${mm}/${yy}`;
};
  useEffect(() => {
    allcatalogueAPI();
  }, []);

  const allcatalogueAPI = async () => {
    try {
      const requestBody = { userid: userID, secret: "string" };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getCatalogItems`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        setCatalogue(response.data.response);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleAddItem = () => {
  const { selectedItem, mfgDate, expDate, mrp, quantity } = formData;
  if (!selectedItem || !mfgDate || !expDate || !mrp || quantity < 1) {
    alert("Please fill all fields for the item");
    return;
  }

  // Update items list
  const newItems = [
    ...itemsToPrint,
    { ...selectedItem, mfgDate, expDate, mrp, quantity }
  ];
  setItemsToPrint(newItems);

  // Generate labels immediately
  const allLabels = [];
  newItems.forEach((item) => {
    for (let i = 0; i < item.quantity; i++) {
      allLabels.push(item);
    }
  });
  setLabels(allLabels);

  // Reset form
  setFormData({
    selectedCategory: "",
    selectedItem: null,
    mfgDate: "",
    expDate: "",
    mrp: "",
    quantity: 1,
  });
};
  const handleGenerate = () => {
    const allLabels = [];
    itemsToPrint.forEach((item) => {
      for (let i = 0; i < item.quantity; i++) {
        allLabels.push(item);
      }
    });
    setLabels(allLabels);
  };

const handlePrint = () => {
  const htmlContent = `
    <html>
      <head>
        <title>Print Labels</title>
        <style>
          @page {
            size: A4;
            margin: 10mm; /* no page margins */
          }
          html, body {
            margin: 0;
            padding: 0;
            height: 100%;
            width: 100%;
          }
          body {
            font-family: sans-serif;
            -webkit-print-color-adjust: exact;
          }
          .label-sheet {
            width: 210mm; /* exact A4 width */
            height: 297mm; /* exact A4 height */
            display: grid;
            grid-template-columns: repeat(3, 64mm);
            grid-template-rows: repeat(8, 34mm);
            gap: 0mm;
            padding-top: 10mm;
            padding-left: 10mm;
            padding-right: 10mm;
            margin-top: 0mm; 
            box-sizing: border-box;
          }
          .label {
            width: 64mm;
            height: 34mm;
            margin: 5mm;
            box-sizing: border-box;
            padding: 1mm;
            text-align: center;
            font-size: 12px;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            border: 0.1mm solid transparent; /* optional debug */
          }
          .barcode-wrapper {
            width: 100%;
            display: flex;
            justify-content: center;
          }
        </style>
      </head>
      <body>
        <div class="label-sheet">
          ${printRef.current.innerHTML}
        </div>
      </body>
    </html>
  `;

  const win = window.open("", "", "height=900,width=1200");
  if (!win) return; // prevent errors if popup blocked

  win.document.write(htmlContent); // single string, no deprecated warning
  win.document.close();
  win.focus();

  setTimeout(() => {
    win.print();
    win.close();
  }, 500);
};

const handlePrintPOS = () => {
  const htmlContent = `
    <html>
      <head>
        <title>Print POS Labels</title>
        <style>
          @page {
            size: 50mm auto;   /* ✅ width fixed, height auto */
            margin: 0;
          }
          body {
            margin: 0;
            padding: 0;
            width: 50mm;
            font-family: "sans-serif"; 
            -webkit-print-color-adjust: exact;
          }
          .pos-label {
            width: 50mm;
            height: 25mm;         /* ✅ exact label height */
            margin-bottom: 3.5mm;   /* ✅ exact gap */
            box-sizing: border-box;
            text-align: center;
            font-size: 10px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
             padding: 1mm 1mm; 
            page-break-inside: avoid;
          }
          .barcode-wrapper {
            width: 100%;
            display: flex;
            justify-content: center;
          }
        </style>
      </head>
      <body>
        ${posRef.current.innerHTML}
      </body>
    </html>
  `;

  const win = window.open("", "", "height=600,width=400");
  if (!win) return;

  win.document.write(htmlContent);
  win.document.close();
  win.focus();

  setTimeout(() => {
    win.print();
    win.close();
  }, 500);
};

const layouts = {
  layout1: { columns: 5, fontSize: "10px" }, // More columns = smaller font
  layout2: { columns: 4, fontSize: "12px" },
  layout3: { columns: 3, fontSize: "14px" },
  layout4: { columns: 2, fontSize: "16px" },
  layout5: { columns: 1, fontSize: "18px" }, // Single column = largest font
};

  const isCategorySelected = !!formData.selectedCategory;
  const isItemSelected = !!formData.selectedItem;

  return (
    <>
  
            <div
              className="p-4 bg-white"
              style={{
                // backgroundColor: "#F8F8F8",
                fontFamily: "Nunito, sans-serif",
              }}
            >
      <div className="bg-white px-4 d-flex">
  <div className="CreateCampaign p-0 m-0 mb-2">Label Printing System</div>
  </div>
      <div className="row m-0 p-0 bg-white px-4 d-flex justify-content-between ">
      
      {/* Left: Form */}
      <div className="col-6 m-0 p-0">
        {/* Form Card */}
      <div
  style={{
    border: "1px solid #e0e0e0",
    borderRadius: "12px",
    padding: "20px",
    background: "#ffffff",
  }}
>
  <h3
    style={{
      marginBottom: "16px",
      fontSize: "18px",
      fontWeight: "600",
      color: "#2c3e50",
      borderBottom: "2px solid #f0f0f0",
      paddingBottom: "6px",
    }}
  >
     Create Label
  </h3>

  <div
    style={{
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "15px",
    }}
  >
    {/* Category */}
    <div>
      <label
        style={{ display: "block", fontSize: "13px", fontWeight: "500", color: "#555", marginBottom: "4px" }}
      >
        Category
      </label>
      <select
        value={formData.selectedCategory}
        onChange={(e) =>
          setFormData((prev) => ({
            ...prev,
            selectedCategory: e.target.value,
            selectedItem: null,
          }))
        }
        style={{
          width: "100%",
          padding: "8px 10px",
          border: "1px solid #ccc",
          borderRadius: "6px",
          fontSize: "14px",
          backgroundColor: "#fafafa",
        }}
      >
        <option value="">Select Category</option>
        {catalogue.map((cat) => (
          <option key={cat.cat_id} value={cat.cat_id}>
            {cat.category_name}
          </option>
        ))}
      </select>
    </div>

    {/* Item */}
    <div>
      <label
        style={{ display: "block", fontSize: "13px", fontWeight: "500", color: "#555", marginBottom: "4px" }}
      >
        Item
      </label>
      <select
        disabled={!isCategorySelected}
        value={formData.selectedItem?.item_id || ""}
        onChange={(e) => {
          const cat = catalogue.find((c) => c.cat_id === formData.selectedCategory);
          const item = cat.menu_items.find((i) => i.item_id === e.target.value);
          setFormData((prev) => ({ ...prev, selectedItem: item }));
        }}
        style={{
          width: "100%",
          padding: "8px 10px",
          border: "1px solid #ccc",
          borderRadius: "6px",
          fontSize: "14px",
          backgroundColor: isCategorySelected ? "#fafafa" : "#f5f5f5",
        }}
      >
        <option value="">Select Item</option>
        {isCategorySelected &&
          catalogue
            .find((c) => c.cat_id === formData.selectedCategory)
            ?.menu_items.map((item) => (
              <option key={item.item_id} value={item.item_id}>
                {item.item_name}
              </option>
            ))}
      </select>
    </div>

    {/* Dates */}
    <div>
      <label
        style={{ display: "block", fontSize: "13px", fontWeight: "500", color: "#555", marginBottom: "4px" }}
      >
        MFG Date
      </label>
      <input
        type="date"
        disabled={!isItemSelected}
        value={formData.mfgDate}
        onChange={(e) => setFormData((prev) => ({ ...prev, mfgDate: e.target.value }))}
        style={{
          width: "100%",
          padding: "8px 10px",
          border: "1px solid #ccc",
          borderRadius: "6px",
          fontSize: "14px",
          backgroundColor: isItemSelected ? "#fafafa" : "#f5f5f5",
        }}
      />
    </div>
    <div>
      <label
        style={{ display: "block", fontSize: "13px", fontWeight: "500", color: "#555", marginBottom: "4px" }}
      >
        EXP Date
      </label>
      <input
        type="date"
        disabled={!isItemSelected}
        value={formData.expDate}
        onChange={(e) => setFormData((prev) => ({ ...prev, expDate: e.target.value }))}
        style={{
          width: "100%",
          padding: "8px 10px",
          border: "1px solid #ccc",
          borderRadius: "6px",
          fontSize: "14px",
          backgroundColor: isItemSelected ? "#fafafa" : "#f5f5f5",
        }}
      />
    </div>

    {/* Price & Quantity */}
    <div>
      <label
        style={{ display: "block", fontSize: "13px", fontWeight: "500", color: "#555", marginBottom: "4px" }}
      >
        MRP
      </label>
      <input
        type="number"
        disabled={!isItemSelected}
        value={formData.mrp}
        onChange={(e) => setFormData((prev) => ({ ...prev, mrp: e.target.value }))}
        style={{
          width: "100%",
          padding: "8px 10px",
          border: "1px solid #ccc",
          borderRadius: "6px",
          fontSize: "14px",
          backgroundColor: isItemSelected ? "#fafafa" : "#f5f5f5",
        }}
      />
    </div>
    <div>
      <label
        style={{ display: "block", fontSize: "13px", fontWeight: "500", color: "#555", marginBottom: "4px" }}
      >
       Label Quantity
      </label>
      <input
        type="number"
        min="1"
        disabled={!isItemSelected}
        value={formData.quantity}
        onChange={(e) => setFormData((prev) => ({ ...prev, quantity: parseInt(e.target.value) }))}
        style={{
          width: "100%",
          padding: "8px 10px",
          border: "1px solid #ccc",
          borderRadius: "6px",
          fontSize: "14px",
          backgroundColor: isItemSelected ? "#fafafa" : "#f5f5f5",
        }}
      />
    </div>

   
  </div>

  <button
  className="bg-green-filter"
    style={{
      marginTop: "20px",
      color: "#fff",
      padding: "10px 18px",
      border: "none",
      borderRadius: "6px",
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: "500",
      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
      transition: "0.2s ease",
    }}
    onMouseOver={(e) => (e.target.style.opacity = "0.9")}
    onMouseOut={(e) => (e.target.style.opacity = "1")}
    onClick={handleAddItem}
  >
    Create
  </button>
</div>






        {/* Print Button */}
        {labels.length > 0 && (
          <>
              <button
          className="mt-5 text-center me-4"
            style={{ background: "#2196F3", color: "#fff", padding: "10px 22px", border: "none", borderRadius: "4px" }}
            onClick={handlePrintPOS}
          >
            Print Labels (POS)
          </button>
          <button
          className="mt-5 text-center "
            style={{ background: "#2196F3", color: "#fff", padding: "10px 22px", border: "none", borderRadius: "4px" }}
            onClick={handlePrint}
          >
            Print Labels (A4)
          </button>
       
          </>
        )}
      </div>

    
<div className="row mt-4 p-0 m-0">
  {/* Left: POS Preview */}
  <div className="col-6 m-0 p-0">
    <h5 className="ms-4">POS Preview (50mm × 25mm)</h5>
  

<div ref={posRef} className="ms-4 mt-3" >
  {labels.map((label, idx) => (
    <div
      key={idx}
      className="pos-label"
      style={{
        width: "50mm",
        height: "25mm",
        marginBottom: "3.5mm",   //  gap between stickers
        boxSizing: "border-box",
        textAlign: "center",
        fontSize: "12px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
         padding: "1.5mm 1mm", 
        // transform: "rotate(180deg)", 
        // border: "0.1mm solid #000",
      }}
    >
      <div style={{  lineHeight: "1.1"  ,marginTop:"1mm"}}>
        MRP: ₹{label.mrp}
      </div>
      <div style={{ lineHeight: "1.1" }}>
        {label.item_name}
      </div>
      <div style={{ lineHeight: "1.1" }}>
        MFG: {formatDate(label.mfgDate)} | EXP: {formatDate(label.expDate)}
      </div>
      <div className="barcode-wrapper">
        <Barcode
          value={label.item_id}
          width={2}
          height={25}   // ✅ barcode fits inside 25mm height
          displayValue={false}
          margin={0}
        />
      </div>
    </div>
  ))}
</div>


  </div>

  {/* Right: A4 Preview (your old code) */}
  <div className="col-6 m-0 p-0">
    <h5 className="ms-4">A4 Preview (3×8 Labels)</h5>
 

    <div
      ref={printRef}
      className="ms-4 mt-3"
      style={{
        width: "210mm",
        height: "297mm",
        padding: "0mm",
        boxSizing: "border-box",
        display: "grid",
        gridTemplateColumns: "repeat(3, 64mm)",
        gridTemplateRows: "repeat(8, 34mm)",
        gap: "0mm",
        justifyContent: "start",
        alignContent: "start",
      }}
    >
      {labels.map((label, idx) => (
        <div
          key={idx}
          style={{
            width: "64mm",
            height: "34mm",
            boxSizing: "border-box",
            textAlign: "center",
            fontSize: "12px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ lineHeight: "1.1" }}>MRP: ₹{label.mrp}</div>
          <div style={{ fontWeight: "bold", lineHeight: "1.1" }}>{label.item_name}</div>
          <div style={{ lineHeight: "1.1", fontSize: "9px" }}>
            MFG: {formatDate(label.mfgDate)} | EXP: {formatDate(label.expDate)}
          </div>
          <div className="barcode-wrapper">
            <Barcode
              value={label.item_id}
              width={2.3}
              height={60}
              displayValue={false}
              margin={2}
            />
          </div>
        </div>
      ))}
    </div>
  </div>
</div>


      </div>
    </div>
    </>
  );
}
